export default "__VITE_ASSET__b43411d1__"